import { Box } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { PartyPc } from "@/lib/core/schemas/party-view";

export function InventoryPanel({ pc }: { pc: PartyPc | null }) {
  if (!pc) {
    return (
      <div className="py-8 text-center text-muted-foreground text-sm">
        No character selected.
      </div>
    );
  }

  if (pc.inventory.length === 0) {
    return (
      <div className="py-8 text-center text-muted-foreground text-sm">
        Inventory is empty.
      </div>
    );
  }

  return (
    <ul className="space-y-2">
      {pc.inventory.map((item) => (
        <li
          className="flex items-center gap-3 rounded-md border border-border bg-card px-3 py-2"
          key={item.id}
        >
          <div className="rounded-md bg-secondary p-2 text-muted-foreground">
            <Box className="h-5 w-5" />
          </div>
          <span className="min-w-0 flex-1 truncate font-medium text-foreground text-sm">
            {item.name}
          </span>
          {item.equipped && (
            <Badge className="text-[10px]" variant="default">
              Equipped
            </Badge>
          )}
        </li>
      ))}
    </ul>
  );
}
